/**
 * @generated SignedSource<<c05ecda955e42b1e6a58f687b8138bf1>>
 * @relayHash 83ff261791dbb3eb4656fed593833922
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83ff261791dbb3eb4656fed593833922

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type examsRegistrationWasUpdatedSubscription$variables = {
  examId: string;
};
export type examsRegistrationWasUpdatedSubscription$data = {
  readonly registrationWasUpdated: {
    readonly registration: {
      readonly currentPin: string | null;
      readonly id: string;
      readonly pinValidated: boolean;
    };
  };
};
export type examsRegistrationWasUpdatedSubscription = {
  response: examsRegistrationWasUpdatedSubscription$data;
  variables: examsRegistrationWasUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "examId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "examId",
        "variableName": "examId"
      }
    ],
    "concreteType": "RegistrationWasUpdatedPayload",
    "kind": "LinkedField",
    "name": "registrationWasUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Registration",
        "kind": "LinkedField",
        "name": "registration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentPin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pinValidated",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "examsRegistrationWasUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "examsRegistrationWasUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "83ff261791dbb3eb4656fed593833922",
    "metadata": {},
    "name": "examsRegistrationWasUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "0547b3c56cbcba722c8639edaf6f80f0";

export default node;
